import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  OnBoardingType,
  OnBoardingVideosResponse,
  OnBoardingVideoType
} from '@app/shared/interfaces/user/user-onboarding.interface';

import { ApiUrls } from '../api/api.urls.service';

@Injectable({
  providedIn: 'root'
})
export class ContentService {
  constructor(private http: HttpClient, private apiUrls: ApiUrls) {}

  getOnBoardingContent(
    companyCode: string,
    type: OnBoardingType,
    videoType: OnBoardingVideoType
  ): Observable<OnBoardingVideosResponse[]> {
    let params = new HttpParams();
    params = params.set('company_code', companyCode);
    params = params.set('type', type);
    params = params.set('step', videoType);

    return this.http.get<OnBoardingVideosResponse[]>(this.apiUrls.content.onboarding, { params });
  }
}
